"use client"

import Link from "next/link"

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { cn } from "@/components/ui/utils"
import { type FaqItem } from "@/components/faq/faq-data"

type FaqExplorerProps = {
  items: readonly FaqItem[]
  className?: string
}

export function FaqExplorer({
  items,
  className,
}: FaqExplorerProps) {
  return (
    <div className={cn("mx-auto w-full max-w-3xl", className)}>
      <Accordion
        className="space-y-4"
        collapsible
        defaultValue={items[0]?.id}
        type="single"
      >
        {items.map((item) => (
          <AccordionItem key={item.id} value={item.id}>
            <AccordionTrigger>
              {item.question}
            </AccordionTrigger>
            <AccordionContent>
              <div className="max-w-[64ch] space-y-4">
                {item.answer
                  .split("\n")
                  .filter((paragraph) => paragraph.trim().length > 0)
                  .map((paragraph, index) => (
                    <p key={`${item.id}-paragraph-${index}`}>{paragraph}</p>
                  ))}
              </div>
              {item.readMoreHref ? (
                <Link
                  className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-[hsl(var(--maroon))] transition-colors hover:text-[hsl(var(--ruby))]"
                  href={item.readMoreHref}
                >
                  {item.readMoreLabel ?? "Read more"}
                </Link>
              ) : null}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

    </div>
  )
}
